import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SectionHeading, btnPrimary } from "@/components/kit";
import { PrimaryLink } from "@/components/kit";
import { PROJECT_NAME } from "@/config/actra";

const ENTITY_TYPES = ["AI agents", "Software agents", "Robots", "Drones", "IoT devices", "Machines", "Autonomous services", "Human-operated systems"];

export const About = () => (
    <>
        <PageHeader
            index="09"
            eyebrow="ABOUT ACTRA"
            title={<>THE ACTION ECONOMY<br />IS <span className="text-[#1677FF]">COMING.</span></>}
            description={`${PROJECT_NAME} provides the verification layer that turns autonomous actions into measurable, auditable and economically meaningful events.`}
        />

        <section className="section">
            <div className="shell space-y-14">
                <Reveal>
                    <div className="relative overflow-hidden border border-white/[0.08]">
                        <img src="/actra.png" alt="ACTRA — a world where actions create value" className="block w-full object-contain" loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#040811] via-transparent to-transparent" />
                    </div>
                </Reveal>

                <div className="grid gap-12 lg:grid-cols-2">
                    <Reveal>
                        <SectionHeading
                            title={<>THE NEXT GENERATION OF<br />THE INTERNET WILL NOT ONLY<br />MOVE INFORMATION.</>}
                            description="It will act."
                        />
                        <ul className="mt-8 space-y-3">
                            {["AI agents will research.", "Software agents will build.", "Robots will inspect.", "Drones will deliver.", "Machines will coordinate."].map((l) => (
                                <li key={l} className="flex items-center gap-3 font-display text-lg font-bold uppercase tracking-tightest text-ink md:text-xl">
                                    <span className="h-1.5 w-1.5 bg-[#1677FF]" aria-hidden="true" /> {l}
                                </li>
                            ))}
                        </ul>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div className="border border-white/[0.08] bg-[#07111F]/70 p-7 md:p-9">
                            <p className="label-tech mb-5">WHO ACTS AUTONOMOUSLY</p>
                            <div className="flex flex-wrap gap-2">
                                {ENTITY_TYPES.map((t) => (
                                    <span key={t} className="border border-white/10 bg-[#0A1627] px-3.5 py-2 font-mono text-[10px] uppercase tracking-[0.16em] text-mute">
                                        {t}
                                    </span>
                                ))}
                            </div>
                            <p className="mt-7 text-sm leading-relaxed text-mute">
                                {PROJECT_NAME} gives these entities something the transaction layer cannot: a record of what they
                                actually did — verified through evidence, scored through reputation, settled through USDC on Arc.
                            </p>
                        </div>
                    </Reveal>
                </div>

                <Reveal>
                    <div className="relative border border-[#1677FF]/30 bg-[#0A1627] p-9 text-center md:p-16">
                        <h2 className="font-display text-[clamp(1.8rem,4.5vw,3.4rem)] font-bold uppercase leading-[1.05] tracking-tightest">
                            DON'T JUST TRUST THE ACTION.
                            <br />
                            <span className="text-[#1677FF]">VERIFY IT.</span>
                        </h2>
                        <div className="mt-8 flex justify-center">
                            <PrimaryLink to="/tasks" testid="about-explore">EXPLORE PROTOCOL</PrimaryLink>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    </>
);

export default About;
